// local hook used in the context of Risk Assessment
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { riskAssessmentAssemblyTemplate } from '@/components/Analysis/state';
import { useGetStructureId } from '@/hooks/useGetStructureId';

export const useRiskFactors = (inputs: { [key: string]: string | null } | undefined) => {
  const structureId = useGetStructureId();
  const template = useAtomValue(riskAssessmentAssemblyTemplate);
  const selectedInputs = useMemo(() => {
    if (inputs && template) {
      const keys = Object.keys(inputs);
      return template?.fields
        .filter((field) => {
          return keys.includes(field?.key!);
        })
        .map((field) => ({
          id: field.key!,
          value: inputs[field?.key!] ?? '',
        }));
    }
    return [];
  }, [inputs, template]);

  return {
    structureId,
    templateId: template?.id!,
    calculatedValues: selectedInputs,
  };
};
